import React, { useState } from 'react';
import { Trash2 } from 'lucide-react';
import { useI18n } from '@monorepo/i18n';
import { TextAreaField, Form } from '@monorepo/forms';
import { useQueryClient } from '@tanstack/react-query';
import { QUERY_KEYS } from '@monorepo/helpers';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter
} from '@fcpartners/uikit-v2/components/ui/dialog';
import { Button } from '@fcpartners/uikit-v2/components/ui/button';
import CancelReasonSelect from './components/CancelReasonSelect';
import formValuesToCancalItem from '../../utils/formValuesToCancalItem';
import useCancelRequest from '../../hooks/useCancelRequest';

const CancelDealModal = ({ dealId }) => {
  const [open, setOpen] = useState(false);
  const { t } = useI18n();
  const queryClient = useQueryClient();
  const { mutate } = useCancelRequest();

  const onSuccess = () => {
    setOpen(false);
    queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.LIST_DEALS_WRAPPER] });
  };

  const handleSave = (data) => {
    mutate(formValuesToCancalItem({ dealId, ...data }), { onSuccess });
  };

  return (
    <>
      <Button
        variant="ghost"
        size="icon"
        onClick={() => setOpen(true)}
        className="h-8 w-8 text-destructive hover:text-destructive hover:bg-destructive/10"
      >
        <Trash2 className="h-4 w-4" />
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="sm:max-w-lg">
          <DialogHeader>
            <DialogTitle>{t('deal.cancel.title')}</DialogTitle>
          </DialogHeader>
          <Form className="space-y-4" onSubmit={handleSave}>
            <CancelReasonSelect
              id="reason"
              name="reason"
              label={t('deal.cancel.form.reason.label')}
            />
            <TextAreaField
              id="reasonComment"
              name="reasonComment"
              label={t('deal.cancel.form.reasoncomment.label')}
              placeholder={t('deal.cancel.form.reasoncomment.placeholder')}
            />
            <DialogFooter>
              <Button
                type="button"
                variant="outline"
                onClick={() => setOpen(false)}
              >
                {t('modal.button.close')}
              </Button>
              <Button type="submit" variant="destructive">
                {t('modal.button.submit')}
              </Button>
            </DialogFooter>
          </Form>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default CancelDealModal;
